// Grafik.tsx
import React, { useEffect, useState } from 'react';
import mobileGraphic from '../assets/mobile-graphic.png';
import webGraphic from '../assets/web-graphic.png';
import './Grafik.css';

// ✅ Move hook outside component
const useIsMobile = (breakpoint: number = 768): boolean => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= breakpoint);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= breakpoint);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [breakpoint]);

  return isMobile;
};

const Grafik: React.FC = () => {
  const isMobile = useIsMobile();

  return (
    <section>
      <img
        src={isMobile ? mobileGraphic : webGraphic}
        alt={isMobile ? 'Mobile Graphic' : 'Web Graphic'}
        className="graphics-image"
      />
    </section>
  );
};

export default Grafik;
